import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import ToolbarButton from '../ToolbarButton/ToolbarButton.js';
import 'classnames';
import '../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/libs/Tooltip';

const ToggleButton = ({
  Icon,
  label,
  onClick,
  dataHook,
  tooltip,
  active,
  disabled,
  setRef
}) => {
  const { isMobile } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement("div", { ref: setRef }, /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      isMobile,
      active,
      tooltip,
      disabled,
      onClick,
      Icon,
      label,
      dataHook
    }
  ));
};

export { ToggleButton as default };
//# sourceMappingURL=ToggleButton.js.map
